import diamondImg from '@src/assets/images/diamond.png';
import { actionTypes } from './actions';

export const initialState = {
  isVisible: false,
  title: '',
  description: '',
  onClose: undefined,
  onUpgrade: undefined,
  img: diamondImg,
  showButtonUnderstand: false,
};

const limitedFeaturesDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_LIMITED_FEATURES_DIALOG: {
      return {
        ...state,
        ...action.payload,
        isVisible: true,
      };
    }
    case actionTypes.HIDE_LIMITED_FEATURES_DIALOG: {
      return {
        ...state,
        isVisible: false,
      };
    }

    default:
      return state;
  }
};

export default limitedFeaturesDialogReducer;
